<template>
  <CFormGroup
      v-bind="{append, prepend, validFeedback, invalidFeedback,
        tooltipFeedback, description, wrapperClasses, class: computedClasses}"
      :style="wrapperAttrs.style"
      :class="wrapperAttrs.class"
  >
    <template #label>
      <slot name="label">
        <label v-if="label" :for="safeId" :class="labelClasses">
          {{ label }}
        </label>
      </slot>
    </template>
    <template #input>
      <input  v-model="filter" placeholder="فیلتر"/>
      <div id="root">
        <div style="display: flex;flex-wrap: wrap">
          <div v-for="icon in icons.filter(x=>x.includes(filter))" :style="`width:fit-content; ${state==icon ? 'border:1px solid red;' : 'padding:1px;'} `" @click="state=icon" >
            <svg style="width: 24px;height: 24px">
              <use :xlink:href="'#'+icon"/>
            </svg>
          </div>

        </div>

      </div>
    </template>

    <template
        v-for="slot in passSlots"
        #[slot]
    >
      <slot :name="slot"></slot>
    </template>
  </CFormGroup>
</template>

<script>
import CFormGroup from '@/coreui/form/CFormGroup.vue'
import {inputProps as props} from '@/coreui/form/form-props'
import * as allFormMixins from '@/coreui/form/form-mixins'

import Treeselect from '@zanmato/vue3-treeselect'
import '@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css'

import {ASYNC_SEARCH} from '@zanmato/vue3-treeselect'
import axios from "@/api/http";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
props.whitout_decimal = Boolean;

const { initialValue, ...mixinMap } = allFormMixins
  const mixins = Object.values(mixinMap)

export default {
  name: 'CInput',
  slots: [
    'prepend',
    'prepend-content',
    'append-content',
    'append',
    'label-after-input',
    'valid-feedback',
    'invalid-feedback',
    'description'
  ],
  inheritAttrs: false,
  emits: ['input', 'change', 'update:value', 'update:modelValue'],
  components: {
    CFormGroup,
    Treeselect
  },
  mixins,
  props,
  data() {
    return {
      icons: [],
      filter: "",


      state: initialValue(this),
      syncTimeout: null,

    }
  },
  mounted() {
    var self = this;
    const icons_pack = document.getElementsByClassName("iconsPack")[0]
    icons_pack.querySelectorAll("symbol").forEach(function (icon) {
      self.icons.push(icon.id)
    })
  },
  computed: {
    passSlots () {
      return this.$options.slots.filter((s) => this.$slots[s])
    },

  },
  watch: {
    'state': function () {

      this.$emit('input', this.state)
        this.$emit('update:modelValue', this.state)
    }
  },
  methods: {
    onInput(e) {

      this.state = e.target.value
      this.$emit('input', this.state, e)
        this.$emit('update:modelValue', this.state)
      if (this.lazy === true) {
        return
      }
      this.syncTimeout = setTimeout(() => {
        this.$emit('update:value', this.state, e)
      }, this.lazy !== false ? this.lazy : 0)
    },
    onChange(e) {
      this.$emit('change', this.state, e)
      this.$emit('update:value', this.state, e)
    },

  },


}
</script>
